export const N76_04 = {
    "columns": 4,
    "rows": 1,
    "visual": {
      "id": 1,
      "type": "line",
      "title": "Monthly Sales",
      "colorTheme": 'colorTheme2',
      "orientation": "horizontal",
      "xAxis": "Sales",
      "yAxis": "",
      "binding": {
        "data": {
          "series": [
            {
              "name": 'Sales',
              "value": 'Sales',
              "type": 'column'
            }
          ],
          "title": "Month",
          "endpoint": "N76.4",
          "parameters": [
            { "key": "FromMonth", "value": "" },
            { "key": "FromYear", "value": "" },
            { "key": "ToMonth", "value": "" },
            { "key": "ToYear", "value": "" },
            { "key": "ConfigTypeCode", "value": "" }
          ]
        },
        "context": {
          "point": {
            "onClick": { }
          }
        }
      }
    }
  }